const progressNum = document.querySelector('#progressNum'); // 数值展示位置
const progressBar = document.querySelector('.progressBar'); // 数值展示位置
let count = 0; // 当前加载图片id
let imgLen = 0; // 预加载图片的数量
const imgPreloader = url => {
    return new Promise((resolve, reject) => {
        let image = new Image();
        image.onload = () => {
            count++;
            /** progressNum是否存在 */
            if (progressBar) {
                progressBar.style.width = `${Math.floor((count / imgLen) * 100)}%`;
            }
            if (progressNum) {
                progressNum.innerHTML = `${Math.floor((count / imgLen) * 100)}%`;
            }
            resolve();
        };
        image.onerror = () => {
            reject();
        };
        image.src = url;
    });
};
export const imgsPreloader = imgs => {
    let promiseArr = [];
    imgLen = imgs.length;
    imgs.forEach(element => {
        promiseArr.push(imgPreloader(element));
    });
    return Promise.all(promiseArr);
};
